import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEpgv2Enabled } from 'helpers/ConfigHelper';
import { noop } from 'helpers/GlobalHelper';
import Style from './ResumeWithProfile.module.scss';

class ResumeWithProfile extends Component {
  componentDidUpdate(prevProps) {
    const { isActive, onRender } = this.props;
    const { isActive: prevIsActive } = prevProps;
    if (!prevIsActive && isActive && onRender) onRender();
  }

  render() {
    const {
      backgroundInline,
      isActive,
      openSignIn,
      openSignUp,
      overlayText,
      perksHeader,
      playFromBeginning,
      profilePerks,
      theme,
    } = this.props;

    if (!isActive) return null;

    const { signInButtonText, signUpButtonText, restartButtonText, moreBenefitsText } = overlayText;
    const innerContainerStyle = backgroundInline && { ...backgroundInline };

    return (
      <div
        className={classNames(
          Style.resumeWithProfile,
          theme.resumeWithProfile,
          isEpgv2Enabled() && Style.resizablePlayer,
        )}
        Style={innerContainerStyle}
      >
        {perksHeader}
        <div className={Style.morePerksSeparator}>
          <div className={Style.morePerksBorder} />
          <div className={Style.morePerksText}>{moreBenefitsText}</div>
          <div className={Style.morePerksBorder} />
        </div>
        <div className={classNames(Style.profilePerkContainer, theme.profilePerkContainer)}>
          {profilePerks}
        </div>
        <div className={Style.actionButtonContainer}>
          <div className={Style.actionButtonInnerContainer}>
            <button onClick={openSignUp} className={classNames(Style.actionButtons, Style.primary)}>
              {signUpButtonText}
            </button>
            <button onClick={openSignIn} className={Style.actionButtons}>
              {signInButtonText}
            </button>
          </div>
          <button
            onClick={playFromBeginning}
            className={classNames(Style.actionButtons, Style.secondaryBtn)}
          >
            {restartButtonText}
          </button>
        </div>
      </div>
    );
  }
}

export default ResumeWithProfile;

ResumeWithProfile.propTypes = {
  backgroundInline: PropTypes.shape({}),
  isActive: PropTypes.bool,
  onRender: PropTypes.func,
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  overlayText: PropTypes.shape({}),
  perksHeader: PropTypes.node,
  playFromBeginning: PropTypes.func,
  profilePerks: PropTypes.arrayOf(PropTypes.node),
  theme: PropTypes.shape({}),
};

ResumeWithProfile.defaultProps = {
  backgroundInline: {},
  isActive: false,
  onRender: null,
  openSignIn: noop,
  openSignUp: noop,
  overlayText: {},
  perksHeader: null,
  playFromBeginning: noop,
  profilePerks: [],
  theme: {},
};
